
  function animateNumberWithCommasAndSuffix(element, targetValue, duration, suffix) {
    const startValue = 0;
    const startTime = performance.now();
    const commaFormatter = new Intl.NumberFormat();

    function updateNumberWithCommasAndSuffix(currentTime) {
      const elapsedTime = currentTime - startTime;
      if (elapsedTime < duration) {
        const progress = elapsedTime / duration;
        const currentNumber = Math.floor(progress * (targetValue - startValue));
        element.textContent = commaFormatter.format(startValue + currentNumber);
        if (suffix) {
          element.textContent += suffix;
        }
        requestAnimationFrame(updateNumberWithCommasAndSuffix);
      } else {
        element.textContent = commaFormatter.format(targetValue);
        if (suffix) {
          element.textContent += suffix;
        }
      }
    }

    requestAnimationFrame(updateNumberWithCommasAndSuffix);
  }

  function handleIntersection(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const numberElement = entry.target.querySelector('.the-number');
        const suffixElement = entry.target.querySelector('.h2:not(.the-number)');
        const targetValue = parseInt(numberElement.textContent.replace(/,/g, ''), 10);
        const suffix = suffixElement ? suffixElement.textContent : '';
        animateNumberWithCommasAndSuffix(numberElement, targetValue, 1500, suffix);
        observer.unobserve(entry.target);
      }
    });
  }

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5
  };

  const observer = new IntersectionObserver(handleIntersection, options);

  const numberBlocks = document.querySelectorAll('.number-block');
  numberBlocks.forEach(block => {
    observer.observe(block);
  });
